export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Product research, organized",

  "nav.home": "Home",
  "nav.buyingGuide": "Buying Guide",
  "nav.guide": "Spreadsheet Guide",
  "nav.categories": "Categories",
  "nav.faq": "FAQ",

  "buttons.allchinabuySpreadsheet": "AllChinaBuy Spreadsheet",
  "buttons.buyItNow": "Buy It Now",
  "buttons.viewCategory": "View category",
  "buttons.browse": "Browse all",

  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",

  "languages.en": "English",
  "languages.fr": "Français",
  "languages.da": "Dansk",
  "languages.de": "Deutsch",

  "footer.disclaimer": "Independent resource · Not the official AllChinaBuy website",
  "footer.rights": "All rights reserved.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.backHome": "Back to home",
  "footer.browseCategories": "Browse categories",
};